module.exports = __webpack_public_path__ + "img/restaurar.bda53ac1.png";